import { render } from "./reportsView3.vue?vue&type=template&id=22ad8738&scoped=true"
import script from "./reportsView3.vue?vue&type=script&lang=js"
export * from "./reportsView3.vue?vue&type=script&lang=js"

import "./reportsView3.vue?vue&type=style&index=0&id=22ad8738&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ad8738"]])

export default __exports__